export default __webpack_public_path__ + "static/media/960.904077bc.png";